import { render, staticRenderFns } from "./EmployeeAbsences.vue?vue&type=template&id=23a1456c&"
import script from "./EmployeeAbsences.vue?vue&type=script&lang=js&"
export * from "./EmployeeAbsences.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeAbsences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports